<script setup>
  import { ref, computed, watchEffect } from 'vue';

  import { useSpotStore } from '@/stores/SpotStore';
  import { useUserStore } from '@/stores/UserStore';

  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';
  import ModalSaveContainerToProfileStep2 from '@/components/ModalSaveContainerToProfileStep2.vue';  
  
  const showModal = defineModel('showModal', { default: true });

  const props = defineProps({
    containerTypeId: {
      type: String,
      required: false
    },
    containerTypeName: {
      type: String,
      required: false
    },  
    settings: {
      type: Object,
      required: true
    }
  });

  const spotStore = useSpotStore();
  const userStore = useUserStore();

  const saveContainerStep = ref(1);
  const savedContainerName = ref(`${spotStore.spotName} - ${props.containerTypeName}`);

  const showStep = computed(() => (step) => saveContainerStep.value === step);

  function closeModal() {
    showModal.value = false;
    saveContainerStep.value = 1;
  }

  async function handleSaveStep1() {
    if (userStore.userProfiles.profiles.length === 1) {
      const profileId = userStore.userProfiles.profiles[0].profile_id;
      await userStore.addContainerToProfile(profileId, props.containerTypeId, savedContainerName.value, props.settings);
      await userStore.getProfiles(true);
    }

    saveContainerStep.value = 2;
  }

  watchEffect(() => {
    if (!showModal.value) saveContainerStep.value = 1;
  });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
  >

    <ModalContentTextInput
      v-if="showStep(1)"
      v-model:savedName="savedName"
      :saveTitleText="`Save ${props.containerTypeName}`"
      acceptButtonText="Continue"
      @accept="handleSaveStep1"
      @cancel="closeModal"
    />

    <ModalSaveContainerToProfileStep2
      v-if="showStep(2)"
      v-model:savedContainerName="savedContainerName"
      :closeModal="closeModal"
      :containerTypeId="props.containerTypeId"
      :containerTypeName="props.containerTypeName"
      :settings="props.settings"
    />  
  </BaseModal>
</template>